import { render, staticRenderFns } from "./AddressInformationSelection.vue?vue&type=template&id=da5179fc&scoped=true&"
import script from "./AddressInformationSelection.vue?vue&type=script&lang=js&"
export * from "./AddressInformationSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5179fc",
  null
  
)

export default component.exports